module.exports = __webpack_public_path__ + "static/media/home.afa9f090.png";